export default __webpack_public_path__ + "4553b614d26705b5450b7ce6450d58dc.svg";